import React from "react";
import { useChildrenProps } from "../../../../hook/ui/common/children/useChildrenProps";

/*
    Wraps the Table component to show a skeleton style loader for the rows

    props
        (boolean, optional)   showRowLoading       When true, the loader will be shown
        (component, optional) RowLoadingComponent  The component to show in each body row cell when the loader is shown 
        (number, optional)    rowLoadingRowCount   The number of rows to show with the loader
*/

const UnstyledTableLoadingWrapper = ({
  classPrepend = "unstyled",
  columns = [],
  rows = [],
  showRowLoading = false,
  RowLoadingComponent = () => /*#__PURE__*/React.createElement("span", null, "Loading..."),
  rowLoadingRowCount = 5,
  onRowClick = null,
  children,
  expandedRowRender = null,
  ...rest
}) => {
  // Create the loading columns by making each column render the RowLoadingComponent
  const loadingColumns = columns.map(column => ({
    ...column,
    sortValueFunc: (cell, row) => cell,
    filterValueFunc: (cell, row) => cell,
    renderCell: () => /*#__PURE__*/React.createElement(RowLoadingComponent, null)
  }));

  // Create a loading row by setting each cell to an empty value
  let loadingRow = {};
  columns.forEach(column => loadingRow[column.dataKey] = "");

  // Create the loading rows list with the number of rows specified by rowLoadingRowCount
  let rowIndexList = [];
  for (let i = 0; i < rowLoadingRowCount; i++) rowIndexList.push(i);
  const loadingRows = rowIndexList.map(() => loadingRow);

  // Use the loading columns and rows when showRowLoading is true
  const [childrenWithProps] = useChildrenProps(children, {
    classPrepend,
    columns: showRowLoading === true ? loadingColumns : columns,
    rows: showRowLoading === true ? loadingRows : rows,
    expandedRowRender: expandedRowRender,
    ...rest,
    enablePagination: !showRowLoading,
    onRowClick: showRowLoading === true ? null : onRowClick
  });
  return childrenWithProps;
};
export { UnstyledTableLoadingWrapper };